__turbopack_context__.v({
  "starIcon": "CTAButton-module__PxcjLa__starIcon",
});
